module.exports = __webpack_public_path__ + "Icon-check-circle.png";